// extracted by mini-css-extract-plugin
module.exports = {"container":"LatestOnWhale_container__3-Sft"};